import { Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { DashboardCard } from "../../../misc/DashboardCard";
import { DrivingSchoolMap } from "../../../misc/maps";
import { useDialog } from "../../../hooks/useDialog";
import { DialogCloseButton } from "../../../misc/DialogCloseButton";
import { SlideUp } from "../../../misc/SlideUp";

export function MapCard(props: { variant?: "default" | "matchGridRow" }) {
  const { variant = "default" } = props;
  const matchesGridRow = variant === "matchGridRow";
  const { openDialog, closeDialog, isDialogOpen } = useDialog("drivingSchoolMap");
  const isLargeScreen = useMediaQuery("(min-width: 1024px)");

  return (
    <>
      <DashboardCard
        title="Standorte Fahrschüler"
        sx={{
          ...(matchesGridRow
            ? { height: { lg: "100%" }, display: { lg: "flex" }, flexDirection: { lg: "column" } }
            : {}),
          "& > .MuiBox-root:last-child": {
            ...(matchesGridRow ? { flex: { lg: 1 }, minHeight: { lg: 0 } } : {}),
            "& > div": {
              ...(matchesGridRow ? { height: { lg: "100%" } } : {}),
              minHeight: { xs: "280px", md: "350px" },
            },
          },
        }}
        topRightCorner={
          isLargeScreen && (
            <IconButton onClick={openDialog}>
              <OpenInFullIcon sx={{ fontSize: 20 }} />
            </IconButton>
          )
        }
      >
        <DrivingSchoolMap />
      </DashboardCard>
      {isDialogOpen && (
        <Dialog
          open
          fullWidth
          maxWidth="lg"
          sx={{ "& .MuiPaper-root": { height: "80vh" } }}
          onClose={closeDialog}
          TransitionComponent={SlideUp}
        >
          <DialogTitle>Standorte Fahrschüler</DialogTitle>
          <DialogCloseButton onClick={closeDialog} />
          <DialogContent>
            <DrivingSchoolMap />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
